import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import AccountIntePage from './AccountIntePage'
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import { FetchDealDetails } from "../../../../Api/Services/DealApiService"
import { fetchDomainAvaliability, extractDomain } from "../../../../Api/Services/CompanyApiService"
// import { FetchContactDetails } from "../../../../Api/Services/ContactApiService"
import { ExchangeCurrency } from '../../Filters/FilterConditions';
import { ReportsIcon, ScoreIcon } from '../../../../components/Icons/Icons';
import Meeting from '../../TablesAndTimelines/MeetingTable'
import Scoring from "../../TablesAndTimelines/ScoringGrapg"
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload'
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';
import { dealInsights } from '../../../../Api/Services/CommonApiService';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, UrlId, NacTrigger, setNaCTrigger, currencySettings, trigger }) => {  // contactListData
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const companyProfile = localData.company
    const [userData, setUserData] = useState()
    // const [contactPerson, setContactPerson] = useState()s
    const [accountData, setAccountData] = useState()
    const [dealData, setDealData] = useState()
    // const [competitionAccount, setCompetitionAccount] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen3, setIsOpen3] = useState(true);
    const [isOpen7, setIsOpen7] = useState(false);
    const [isOpen5, setIsOpen5] = useState(true);
    // const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen6, setIsOpen6] = useState(false);
    // const [isOpen4, setIsOpen4] = useState(false);
    const [report, setReport] = useState()
    const [openIntelligence, setOpenIntelligence] = useState(false);
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    const handleExpand5 = (key) => {
        setIsOpen5(key.length > 0);
    };
    const handleExpand6 = (key) => {
        setIsOpen6(key.length > 0);
    };
    const handleExpand7 = (key) => {
        setIsOpen7(key.length > 0);
    };
    // const handleExpand2 = (key) => {
    //     setIsOpen2(key.length > 0);
    // };
    // const handleExpand4 = (key) => {
    //     setIsOpen4(key.length > 0);
    // };
    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response?.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getAccountData(params) {
        try {
            const responseData = await FetchAccountDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setAccountData(merged)
            if (merged?.website) {
                getAccountReports(merged?.website)
            } else {
                setReport({ allow: false, data: null })
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getDealData(params) {
        try {
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const ConvertRate = currencySettings?.exchangeRate;
            const dealresponse = await FetchDealDetails(params)
            const Response = dealresponse.data
            const CurrecnyDealValue = await ExchangeCurrency(Number(Response.deal_value), ConvertRate)
            const merged = { ...Response, deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)), DataPermission: { isPresent: dealresponse.allow } };
            setDealData(merged)
        } catch (error) {
            message.error(error)
        }
    }
    // async function getCompetitionData(params) {
    //     try {
    //         const competitionArray = params.split(',').map(item => Number(item.trim()));
    //         const results = await Promise.all(
    //             competitionArray.map(async (competitionId) => {
    //                 const Response = await FetchAccountDetails(competitionId)
    //                 const Data = await checkAccountPresence(Response.account_id, accountListData, "Account");
    //                 return { ...Response, DataPermission: Data };
    //             })
    //         );
    //         setCompetitionAccount(results);
    //     } catch (error) {
    //         message.error(error);
    //     }
    // }
    // async function getContactPersons(params) {
    //     try {
    //         const PersonArray = params.split(',').map(item => Number(item.trim()));
    //         const results = await Promise.all(
    //             PersonArray.map(async (PersonId) => {
    //                 const Response = await FetchContactDetails(PersonId)
    //                 const Data = await checkAccountPresence(Response.contacts_id, contactListData, "Contact");
    //                 return { ...Response, DataPermission: Data };
    //             })
    //         );
    //         setContactPerson(results);
    //     } catch (error) {
    //         message.error(error);
    //     }
    // }
    useEffect(() => {
        if (isOpen6) {
            if (displayData?.deal_owner) {
                getUsersData(displayData?.deal_owner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.deal_owner, isOpen6])
    useEffect(() => {
        if (isOpen5) {
            if (displayData?.account_id) {
                getAccountData(displayData?.account_id)
            } else {
                setAccountData()
            }
        }
    }, [displayData?.account_id, isOpen5])
    useEffect(() => {
        if (isOpen7) {
            if (displayData?.parent_deal_id) {
                getDealData(displayData?.parent_deal_id)
            } else {
                setDealData()
            }
        }
    }, [displayData?.parent_deal_id, isOpen7])
    // useEffect(() => {
    //     if (displayData?.competition && accountListData?.length) {
    //         getCompetitionData(displayData?.competition)
    //     }
    // }, [accountListData])
    // useEffect(() => {
    //     if (displayData?.contact_person && contactListData?.length) {
    //         getContactPersons(displayData?.contact_person)
    //     }
    // }, [contactListData])
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const openScoreGeniee = async () => {
        let hideMessage;
        try {
            hideMessage = message.loading("Gathering insights...", 0);
            const response = await dealInsights(companyProfile.companyCode, memoUrlId[1])
            if (response.status === 200) {
                hideMessage();
                dispatch(setChatCall(true));
            }
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            minWidth: 0,
                        }}
                    >
                        <Text
                            strong
                            style={{
                                fontSize: 14,
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                            }}
                        >
                            Deal Score
                        </Text>
                        <div className='Hover-Refresh3 back-hover2 able-style'
                            role="button"
                            tabIndex={0} title='View Score Insights'
                            onClick={(e) => {
                                e.stopPropagation();   // ✅ IMPORTANT
                                openScoreGeniee();
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.stopPropagation();
                                    openScoreGeniee()
                                }
                            }}
                            aria-label='insights'
                        ><ScoreIcon height={20} width={20} /></div>
                    </div>
                    <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                    {/* <div className='RightSide-DataShadow' style={{ padding: "30px 10px" }}> */}
                    <Scoring UrlId={memoUrlId} NacTrigger={NacTrigger} trigger={trigger} />
                    {/* </div> */}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="List" />
            {(displayData?.account_id) && <>
                <Divider style={{ margin: "10px 0" }} />
                <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand5} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                minWidth: 0,
                            }}
                        >
                            <Text
                                strong
                                style={{
                                    fontSize: 14,
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                }}
                            >
                                Account
                            </Text>
                            {isOpen5 ? <div className={!report?.allow ? "disabled-style" : 'Hover-Refresh3 back-hover2 able-style'}
                                role="button"
                                tabIndex={0} title='View Account Intelligence Report'
                                onClick={!report?.allow ? undefined : () => openTacking()}
                                onKeyDown={(event) => {
                                    if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                                        openTacking()
                                    }
                                }}
                                aria-label='report'
                            ><ReportsIcon height={20} width={20} /></div> : <></>}
                        </div>

                        <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen5 ? "Close" : "View"}</Text></div>} key="1">
                        {accountData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${accountData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={accountData?.DataPermission?.isPresent ? () => accountData?.account_id && ViewDetailPage(accountData?.account_id, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(accountData?.account_id, "ACCOUNT")
                                    }
                                }}
                            >
                                {accountData?.account_profile !== null && accountData?.account_profile
                                    !== undefined && accountData?.account_profile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.account_profile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                        {accountData?.account_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.account_name}>{accountData?.account_name}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.account_number}>{accountData?.account_number}</div>
                                </figcaption>
                            </div>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.industry_name && accountData?.industry_name !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                            <br />
                                            <Text >{accountData?.industry_name}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.nom_of_employees && accountData?.nom_of_employees !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                            <br />
                                            <Text >{accountData?.nom_of_employees}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.annual_revenue && accountData?.annual_revenue !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                            <Text >{accountData?.annual_revenue}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.rating && accountData?.rating !== "") ?
                                        <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                            <Text >{accountData?.rating}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            {accountData?.account_owner &&
                                <div><Text type="secondary" className='RightSide-Lable'>Account Owner</Text> <br />
                                    <Text >
                                        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === accountData?.account_owner) && "ListNavigate"}`}
                                            role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                                            tabIndex={0}
                                            onClick={(Role === "Administrator" || profile.userId === accountData?.account_owner) ? () => accountData?.account_owner && ViewDetailPage(accountData?.account_owner, "USER") : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(accountData?.account_owner, "USER");
                                                }
                                            }}> {accountData?.userProfilePic !== null && accountData?.userProfilePic
                                                !== undefined && accountData?.userProfilePic !== "" ?
                                                <figure>
                                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.userProfilePic} alt="" />
                                                </figure>
                                                :
                                                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                    {accountData?.userFirstName?.slice(0, 1).toUpperCase()}
                                                </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={`${accountData?.userFirstName} ${accountData?.userLastName}`}> {`${accountData?.userFirstName} ${accountData?.userLastName}`}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={accountData?.accountOwner}>{accountData?.accountOwner}</div>
                                            </figcaption>
                                        </div>
                                    </Text>
                                </div>
                            }
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse></>}
            <Divider style={{ margin: "10px 0" }} />
            {(displayData?.parent_deal_id) && <>
                <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand7} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Parent Deal</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen7 ? "Close" : "View"}</Text></div>} key="1">
                        {dealData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${dealData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={dealData?.DataPermission?.isPresent ? () => dealData?.deals_id && ViewDetailPage(dealData?.deals_id, "DEAL") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(dealData?.deals_id, "DEAL")
                                    }
                                }}
                            >
                                {dealData?.deal_profile !== null && dealData?.deal_profile
                                    !== undefined && dealData?.account_profile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={dealData?.account_profile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag DealIcon' style={{ flexShrink: 0, }}>
                                        {dealData?.deal_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={dealData?.deal_name}>{dealData?.deal_name}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={dealData?.deal_type_name}>{dealData?.deal_type_name}</div>
                                </figcaption>
                            </div>
                            {(dealData?.pipeline_stage && dealData?.pipeline_stage !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Pipeline Stage</Text>
                                    <br />
                                    <Text ><div className={`table_list_clicks status-text PipeLine${dealData.pipeline_stage}`}>{dealData.pipelineStage}</div>
                                    </Text>
                                </div> : <></>}
                            {(dealData?.deal_value !== undefined && dealData?.deal_value !== null && dealData?.deal_value !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Deal Value ({currencySettings?.currency})</Text>
                                    <br />
                                    <Text>{`${currencySettings?.symbol} ${dealData.deal_value.toLocaleString()}`}</Text>
                                </div> : <></>}
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse> <Divider style={{ margin: "10px 0" }} /> </>}
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand6} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Deal Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen6 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            {/* <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end" >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Competition<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.competition ? displayData.competition.split(',').filter(item => item.trim()).length : 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                    {competitionAccount?.map((item, index) => (
                        <div className='RightSide-DataShadow' key={index}>
                            <div className={`user-info_image ${item?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px" }} tabIndex={0} role="button"
                                onClick={item?.DataPermission?.isPresent ? () => item?.account_id && ViewDetailPage(item?.account_id, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(item?.account_id, "ACCOUNT")
                                    }
                                }}
                            >
                                {item?.account_profile !== null && item?.account_profile
                                    !== undefined && item?.account_profile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px" }} src={item?.account_profile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag AccountIcon'>
                                        {item?.account_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption>
                                    <div>{item?.account_name}</div>
                                    <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.account_number}</div>
                                </figcaption>
                            </div>
                            {(item?.industry_name && item?.industry_name !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                    <br />
                                    <Text >{item?.industry_name}</Text>
                                </div> : <></>}
                            {(item?.nom_of_employees && item?.nom_of_employees !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                    <br />
                                    <Text >{item?.nom_of_employees}</Text>
                                </div> : <></>}
                            {(item?.annual_revenue && item?.annual_revenue !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                    <Text >{item?.annual_revenue}</Text>
                                </div> : <></>}
                            {(item?.rating && item?.rating !== "") ?
                                <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                    <Text >{item?.rating}</Text>
                                </div> : <></>}
                        </div>))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end" >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Contact Persons<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.contact_person ? displayData.contact_person.split(',').filter(item => item.trim()).length : 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                    {contactPerson?.map((item, index) => (<div className='RightSide-DataShadow' key={index}>
                        <div className={`user-info_image ${item?.DataPermission?.isPresent && "ListNavigate"}`}
                            role="button" style={{ padding: "0px 0px 10px" }}
                            tabIndex={0}
                            onClick={item?.DataPermission?.isPresent ? () => item?.contacts_id && ViewDetailPage(item?.contacts_id, "CONTACT") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(item?.contacts_id, "CONTACT")
                                }
                            }}
                        >  {item?.contact_profile !== null && item?.contact_profile
                            !== undefined && item?.contact_profile !== "" ?
                            <figure>
                                <img style={{ width: "30px", height: "30px" }} src={item?.contact_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag ContactIcon'>
                                {item?.first_name?.slice(0, 1).toUpperCase()}
                            </span>
                            }
                            <figcaption>
                                <div> {`${item?.first_name} ${item?.last_name}`}</div>
                                <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.email}</div>
                            </figcaption>
                        </div>
                        {(item?.designation && item?.designation !== "") &&
                            <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                <StaffIcon height={15} width={15} marginRight={5} />{item?.designation}
                            </div>}
                        {(item?.mobile && item?.mobile !== "") &&
                            <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />{item?.mobile}
                            </div>}
                        {item?.account_id &&
                            <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                <AccountsIcon height={15} width={15} marginRight={5} />{item?.account_name}
                            </div>}
                    </div>))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} /> */}
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end" >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.deal_files?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.deal_files?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />

        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    // Role: PropTypes.string.isRequired
    // contactListData: PropTypes.array.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    currencySettings: PropTypes.object.isRequired,
};
export default NoteDetails;
